import React, { Fragment } from 'react';
import {
  string,
  shape,
  arrayOf,
  func,
} from 'prop-types';
import {
  Paragraph,
  Block,
  Input,
  Button,
  Small,
  Separator,
  Link,
} from 'components/common';
import { ValidationUtils } from '@hyphengroup/cag-components';
import { Mutation } from 'react-apollo';
import AddNewsletterSubscription from 'queries/newsletterSubscription.gql';
import withApplicationConfig from 'containers/withApplicationConfig';
import { subscribeBtnTracking, withTracking } from 'components/tracking';
import AgreementText from './AgreementText';
import './NewsLetterPanel.scss';

export const staticTextKeys = [
  'NEWSLETTER_SIGNUP_ERROR_MESSAGE',
  'NEWSLETTER_SIGNUP_VALIDATION_ERROR_MESSAGE',
  'NEWSLETTER_SIGNUP_SUCCESS_MESSAGE',
];

class NewsLetterPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      success: false,
      isInputValid: false,
      message: '',
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.mutationSuccess = this.mutationSuccess.bind(this);
  }

  handleChange = value => this.setState({
    email: value,
  });

  mutationSuccess() {
    const { staticText } = this.props;
    this.setState({
      success: true,
      message: staticText.NEWSLETTER_SIGNUP_SUCCESS_MESSAGE,
    });
  }

  handleSubmit(mutate) {
    const { language, track, page } = this.props;
    const { email, isInputValid } = this.state;

    if (isInputValid) {
      subscribeBtnTracking(track, page);
      mutate({
        variables: {
          email,
          language,
          skipWelcome: false,
          source: 'WEB',
        },
      });
    }
  }

  render() {
    const {
      heading,
      subheading,
      separatorText,
      emailSubscription,
      facebookLikeCta,
      subscribeButtonLabel,
      staticText,

      // TODO: missing from grpahQL
      links,
      extraMethod,
      agreementText,
    } = this.props;
    const {
      isInputValid,
      success,
      message,
    } = this.state;
    const { isEmail } = ValidationUtils;

    return (
      <Mutation
        mutation={AddNewsletterSubscription}
        onCompleted={this.mutationSuccess}
      >
        {(addNewsletterSubscription, { loading, error }) => (
          <div className="newsLetter-panel-wrapper">
            <Block>
              <Block.Header
                title={heading}
                subtitle={subheading}
              />
              <div className="container-wrapper">
                <div className="newsletter-panel-form">
                  <div className="newsletter-panel-input-wrapper">
                    <div className="newsletter-panel-input">
                      {emailSubscription && (
                        <Input
                          dataSelectorId="newsletter-panel-input"
                          title={emailSubscription.fieldLabel}
                          showSuccessIcon={false}
                          disabled={success}
                          type="email"
                          name="email"
                          autoComplete="email"
                          placeholder={emailSubscription.fieldPlaceholder}
                          onChange={this.handleChange}
                          validate={(v) => {
                            if (!v || v.length === 0) return '';
                            const isEmailValid = isEmail(v);
                            this.setState({ isInputValid: isEmailValid });
                            return (isEmailValid ? '' : staticText.NEWSLETTER_SIGNUP_VALIDATION_ERROR_MESSAGE);
                          }}
                          isSuccessMessage={!error}
                          showMessageIcon
                          message={error ? staticText.NEWSLETTER_SIGNUP_ERROR_MESSAGE : message}
                          displayMessageForTouchedState={true}
                        />
                      )}
                    </div>
                    <div className="newsletter-panel-submit-button">
                      <div className="text-space">
                        &nbsp;
                      </div>
                      <Button
                        disabled={!isInputValid || success}
                        fluid
                        loading={loading}
                        onClick={() => {
                          this.handleSubmit(addNewsletterSubscription);
                        }}
                        dataSelectorId="newsletter-panel-submit-button"
                      >
                        {emailSubscription.subscribeCta || subscribeButtonLabel}
                      </Button>
                    </div>
                  </div>
                  <div className="newsletter-panel-tnc-wrapper">
                    <div className="newsletter-panel-tnc">
                      <Paragraph>
                        <Small secondary>
                          {agreementText && (
                            <AgreementText
                              agreementText={agreementText}
                              links={links}
                            />
                          )}
                        </Small>
                      </Paragraph>
                    </div>
                  </div>
                  {facebookLikeCta && (
                    <Fragment>
                      <Separator text={separatorText} />
                      <div className="newsletter-panel-sm-button">
                        <Link to={extraMethod && extraMethod.url}>
                          <Button
                            fluid
                            styleName="ghost"
                          >
                            {facebookLikeCta}
                          </Button>
                        </Link>
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </Block>
          </div>
        )}
      </Mutation>
    );
  }
}

NewsLetterPanel.defaultProps = {
  heading: null,
  subheading: null,
  separatorText: 'or',
  agreementText: null,
  emailSubscription: null,
  subscribeButtonLabel: null,
  links: null,
  facebookLikeCta: null,
  extraMethod: null,
  track: func,
};

NewsLetterPanel.propTypes = {
  heading: string,
  language: string.isRequired,
  subheading: string,
  separatorText: string,
  agreementText: string,
  subscribeButtonLabel: string,
  emailSubscription: shape({
    fieldLabel: string,
    fieldPlaceholder: string,
    subscribeCta: string,
  }),
  links: arrayOf(
    shape({
      id: string,
      href: string,
      Label: string,
    }),
  ),
  facebookLikeCta: string,
  extraMethod: shape({
    url: string.isRequired,
  }),
  staticText: shape({}).isRequired,
  track: null,
  page: string,
};

export default withTracking(withApplicationConfig(NewsLetterPanel, 'newsletterPanel'));
